// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3KuXk","col":"styles_col__2uO5u","fulfillmentStatus":"styles_fulfillmentStatus__2dZ_P","emailCol":"styles_emailCol__18ol0"};